import * as React from "react";
import classnames from "classnames";
import { Logo } from "@grandvisionhq/common";
import NavigationContainer from "../../../../Navigation/v3/components/Navigation/NavigationContainer.js";
/* empty css            */
const Header = ({
  className,
  logo,
  isMobile,
  hasNavigation = true,
  title,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("book-appointment-header", className) }, /* @__PURE__ */ React.createElement(
  "header",
  {
    className: classnames("book-appointment-header__header", {
      "book-appointment-header__header--has-only-logo": !hasNavigation
    })
  },
  logo && /* @__PURE__ */ React.createElement(Logo, { className: "book-appointment-header__logo", url: "/", image: logo, title }),
  hasNavigation && /* @__PURE__ */ React.createElement(NavigationContainer, { className: "book-appointment-header__navigation" })
));
export {
  Header as default
};
//# sourceMappingURL=Header.js.map
